/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import { Tooltip } from "@mui/material";
import React from "react";
import { BsPlus } from "react-icons/bs";
import { MdKeyboardArrowRight } from "react-icons/md";
import { RiSave3Line } from "react-icons/ri";
// import { useHistory } from "react-router-dom";

import { RenderByCargo } from "utils/RenderByCargo";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import * as IconsSvg from "../../assets/iconsSVG";
import icons from "../../constants/icons";
import CustomButton from "../@button";
import * as Styles from "./styles";

interface Props {
  showButtonSave?: boolean;
  onBack: Function;
  onChangeActionNew: any;
  onSave?: Function;
  showButtonNew?: boolean;
  showDrop?: boolean;
  options?: JSX.Element;
  open?: boolean;
  setOpen?: Function;
  breadcrumbs: Array<{
    path: string;
    name: string;
  }>;
  loading?: boolean;
  notSave?: boolean;
}
const navCommon: React.FC<Props> = ({
  onBack,
  onChangeActionNew,
  showButtonNew,
  open,
  setOpen,
  showDrop,
  options,
  breadcrumbs,
  showButtonSave,
  onSave,
  loading,
}) => {
  // const history = useHistory();
  // const [isButtonDisabled, setButtonDisabled] = React.useState(false);
  const { codigoCargo2013, usuarioBackofficeVivaz } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  const homePath = usuarioBackofficeVivaz ? "/funil-de-propostas" : "/menu";

  const handleClick = () => {
    setTimeout(() => {}, 5000);
    return onSave && onSave();
  };

  return (
    <Styles.Card>
      <Styles.ContainerRow>
        <Styles.Row>
          <div
            onClick={() => {
              onBack();
            }}
            style={{ marginRight: 6, cursor: "pointer" }}
          >
            <div
              style={{
                border: `1px solid #2D5BFF`,
                width: 24,
                height: 24,
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                style={{ color: "#2D5BFF", fontSize: "1.0em" }}
                className="las la-undo"
              />
            </div>
          </div>
          {/* {notSave && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FDE4E4",
                height: 20,
                marginLeft: 13,
                marginRight: 8,
                borderRadius: 30,
                paddingTop: 2,
                paddingBottom: 2,
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              <Typography
                text="Não Salvo"
                color="#F43636"
                variant="body2"
                fontSize={12}
              />
            </div>
          )} */}
          <Styles.IconHome href={homePath}>
            <IconsSvg.FilledHouseIcon />
          </Styles.IconHome>
          <MdKeyboardArrowRight
            size={14}
            color="#7e8794"
            style={{ marginTop: 1, marginRight: 2 }}
          />
          <Styles.Nav separator="›" aria-label="breadcrumb">
            {breadcrumbs.map(
              (item: { path: string; name: string }, index: number) => {
                if (!item.path) {
                  return <Styles.Span key={index}>{item.name}</Styles.Span>;
                }
                return (
                  <Styles.Route
                    to={item.path}
                    key={index.toString()}
                    color="inherit"
                  >
                    {item.name}
                  </Styles.Route>
                );
              }
            )}
          </Styles.Nav>
        </Styles.Row>
        <Styles.Row>
          {/* <RenderByCargo
            cargo={codigoCargo2013}
            isCorretor={
              <>
                {showButtonNew && (
                  <>
                    <CustomButton
                      onPress={() => onChangeActionNew(true)}
                      disabled={loading}
                      size="medium"
                      textButton="NOVO"
                      backgroundColor="transparent"
                      color="#2D5BFF"
                      icon={<BsPlus style={{ marginLeft: 4 }} />}
                    />
                    <Styles.Space style={{ width: 8 }} />
                  </>
                )}
              </>
            }
          /> */}

          {showButtonSave && (
            <>
              <CustomButton
                disabled={loading}
                size="medium"
                onPress={handleClick}
                textButton="SALVAR"
                backgroundColor="transparent"
                color="#2E5BFF"
                icon={
                  loading ? (
                    <Styles.LoadingSave
                      style={{
                        marginLeft: 4,
                        width: 16,
                        height: 16,
                        color: "#2E5BFF",
                      }}
                    />
                  ) : (
                    <RiSave3Line
                      style={{ marginLeft: 4, width: 16, height: 16 }}
                    />
                  )
                }
              />
              <Styles.Space style={{ width: 20 }} />
            </>
          )}
          {showDrop ? (
            <Tooltip title="Outras opções " placement="top" followCursor arrow>
              <Styles.OnPress
                onClick={(event) => setOpen && setOpen(event)}
                aria-describedby="poper"
              >
                <Styles.Img height={14} src={icons.pingIcon} />
              </Styles.OnPress>
            </Tooltip>
          ) : null}
        </Styles.Row>
      </Styles.ContainerRow>
      {open === true ? <Styles.DropDown>{options}</Styles.DropDown> : null}
    </Styles.Card>
  );
};
export default navCommon;
